import { createApiClient } from "./client";

const BASE_URL = process.env.REACT_APP_API_URL || "";
export const api = createApiClient(BASE_URL);